import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Dashboard from "../pages/dashboard/page";
import FizboPage from "../pages/fizbo/page";
import PortfoyPage from "../pages/portfoy/page";
import TalepBulPage from "../pages/talep-bul/page";
import MusteriRehberPage from "../pages/musteri-rehber/page";
import TopluMesajPage from "../pages/toplu-mesaj/page";
import HatirlatmalarPage from "../pages/hatirlatmalar/page";
import RaporlarPage from "../pages/raporlar/page";
import AyarlarPage from "../pages/ayarlar/page";
import FizboKanbanPage from "../pages/fizbo-kanban/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/fizbo",
    element: <FizboPage />,
  },
  {
    path: "/fizbo-kanban",
    element: <FizboKanbanPage />,
  },
  {
    path: "/portfoy",
    element: <PortfoyPage />,
  },
  {
    path: "/talep-bul",
    element: <TalepBulPage />,
  },
  {
    path: "/musteri-rehber",
    element: <MusteriRehberPage />,
  },
  {
    path: "/toplu-mesaj",
    element: <TopluMesajPage />,
  },
  {
    path: "/hatirlatmalar",
    element: <HatirlatmalarPage />,
  },
  {
    path: "/raporlar",
    element: <RaporlarPage />,
  },
  {
    path: "/ayarlar",
    element: <AyarlarPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
